import { api } from "api/api";
import { SimulateCreditData } from "pages/SimulatorCredit";

export interface ResultResponse {
  minimumGrossIncomeRequired: string;
  portionAmount: string;
  paymentTerm: string;
  interestRate: string;
}

export const simulatorCreditService = {
  simulate(params: SimulateCreditData) {
    const response = api.post("/price", { ...params, guarantee: true });
    return response;
  },
};
